(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["beauty-community"] && !Shopify.designMode) return;
  try {
    
function beautyCommunityInit(){document.querySelectorAll('[data-beauty-community]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='1';const loadScript=(id,src,done)=>{const found=document.getElementById(id);if(found){if(found.dataset.loaded)done?.();else found.addEventListener('load',()=>done?.(),{once:true});return}const script=document.createElement('script');script.id=id;script.src=src;script.async=true;script.addEventListener('load',()=>{script.dataset.loaded='1';done?.()},{once:true});script.addEventListener('error',()=>{script.remove()},{once:true});document.head.append(script)};root.querySelector('[data-load-tiktok]')?.addEventListener('click',()=>{const host=root.querySelector('[data-tiktok-host]');if(host.dataset.loaded)return;const content=host.querySelector('template').content.cloneNode(true);host.replaceChildren(content);host.dataset.loaded='1';loadScript('beauty-tiktok-script','https://www.tiktok.com/embed.js')});if('IntersectionObserver' in window){const observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){root.querySelector('[data-load-tiktok]')?.click();observer.disconnect()}},{rootMargin:'150px'});observer.observe(root.querySelector('[data-tiktok-host]'))}root.querySelectorAll('[data-load-instagram]').forEach(button=>button.addEventListener('click',()=>{const host=button.closest('[data-instagram-host]');if(host.dataset.loaded)return;const content=host.querySelector('template').content.cloneNode(true);host.replaceChildren(content);host.dataset.loaded='1';loadScript('beauty-instagram-script','https://www.instagram.com/embed.js',()=>window.instgrm?.Embeds?.process())}))})}beautyCommunityInit();document.addEventListener('shopify:section:load',beautyCommunityInit);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["beauty-header"]) return;
  try {
    
function beautyHeaderInit(){document.querySelectorAll('[data-beauty-search]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='1';const input=root.querySelector('input[type=search]'),box=root.querySelector('.bl-search-results'),list=box.querySelector('ul'),status=box.querySelector('p');let timer,controller,version=0;const close=()=>{box.hidden=true;input.setAttribute('aria-expanded','false')};const open=()=>{box.hidden=false;input.setAttribute('aria-expanded','true')};const normalise=q=>/^cr[eè]me?\s+(?:of\s+)?nat(?:ure)?$/i.test(q.trim())?'Creme of Nature':q.trim();input.addEventListener('input',()=>{clearTimeout(timer);controller?.abort();const current=++version;list.replaceChildren();status.textContent='';close();if(input.value.trim().length<2)return;timer=setTimeout(async()=>{controller=new AbortController();const url=new URL(root.dataset.searchUrl+'.json',location.origin);url.search=new URLSearchParams({q:normalise(input.value),'resources[type]':'product','resources[limit]':'6','resources[options][fields]':'title,vendor,product_type,tag,variants.title,variants.sku,variants.barcode','resources[options][unavailable_products]':'last'}).toString();try{const res=await fetch(url,{signal:controller.signal,headers:{Accept:'application/json'}});if(!res.ok)throw new Error('search');const data=await res.json();if(current!==version)return;for(const product of data.resources.results.products){const target=new URL(product.url,location.origin);if(target.origin!==location.origin)continue;const li=document.createElement('li'),a=document.createElement('a'),span=document.createElement('span');a.href=target.href;span.textContent=product.title;const imageUrl=product.image||product.featured_image?.url;if(imageUrl){const src=new URL(imageUrl,location.origin);if(src.protocol==='https:'){const img=document.createElement('img');img.src=src.href;img.alt='';img.width=48;img.height=48;img.loading='lazy';a.append(img)}}a.append(span);li.append(a);list.append(li)}if(!list.children.length)status.textContent=root.dataset.empty;open()}catch(e){if(e.name==='AbortError'||current!==version)return;status.textContent=root.dataset.error;open()}},180)});input.addEventListener('keydown',e=>{if(e.key==='ArrowDown'&&!box.hidden){e.preventDefault();list.querySelector('a')?.focus()}});root.addEventListener('keydown',e=>{if(e.key==='Escape'){close();root.querySelectorAll('details[open]').forEach(d=>d.open=false);input.focus()}});document.addEventListener('click',e=>{if(!root.contains(e.target)){close();root.querySelectorAll('details[open]').forEach(d=>d.open=false)}});root.querySelectorAll('.bl-nav details').forEach(d=>d.addEventListener('toggle',()=>{if(d.open)root.querySelectorAll('.bl-nav details').forEach(other=>{if(other!==d)other.open=false})}))})}beautyHeaderInit();document.addEventListener('shopify:section:load',beautyHeaderInit);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["beauty-proedge-motion"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('beauty-edge-motion')) {
  customElements.define('beauty-edge-motion', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.panels = Array.from(this.querySelectorAll('[data-edge-panel]'));
      this.tabs = Array.from(this.querySelectorAll('[data-edge-tab]'));
      if (!this.panels.length || this.panels.length !== this.tabs.length) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.index = 0;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.finePointer = matchMedia('(hover: hover) and (pointer: fine)');
      this.manualPause = false;
      this.motionAllowed = this.dataset.motion === 'true';
      this.status = this.querySelector('[role="status"]');
      this.pauseButton = this.querySelector('[data-edge-pause]');
      this.querySelector('[data-edge-tabs]').setAttribute('role', 'tablist');
      this.tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', this.panels[index].id);
        this.panels[index].setAttribute('role', 'tabpanel');
        this.panels[index].setAttribute('aria-labelledby', tab.id);
        tab.addEventListener('click', event => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.select(index, false, true);
        }, options);
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = this.index + 1;
          if (event.key === 'ArrowLeft') next = this.index - 1;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (event.key === ' ') next = index;
          if (next === undefined) return;
          event.preventDefault();
          this.select(next, true, true);
        }, options);
      });
      this.querySelector('[data-edge-prev]').addEventListener('click', () => this.select(this.index - 1, false, true), options);
      this.querySelector('[data-edge-next]').addEventListener('click', () => this.select(this.index + 1, false, true), options);
      this.querySelector('[data-edge-arrows]').hidden = this.panels.length < 2;
      this.pauseButton?.addEventListener('click', () => {
        this.manualPause = !this.manualPause;
        this.updateMotion();
      }, options);
      this.reduced.addEventListener('change', () => this.updateMotion(), options);
      this.addEventListener('pointermove', event => {
        if (!this.moving || !this.finePointer.matches) return;
        const stage = event.target.closest('[data-edge-stage]');
        if (!stage) return;
        const box = stage.getBoundingClientRect();
        const x = Math.max(-1, Math.min(1, (event.clientX - box.left) / box.width * 2 - 1));
        const y = Math.max(-1, Math.min(1, (event.clientY - box.top) / box.height * 2 - 1));
        const pack = stage.querySelector('[data-edge-pack]');
        pack.style.setProperty('--edge-tilt-x', `${-y * 4}deg`);
        pack.style.setProperty('--edge-tilt-y', `${x * 7}deg`);
      }, options);
      this.addEventListener('pointerleave', () => this.resetTilt(), options);
      this.addEventListener('touchstart', event => {
        if (!event.target.closest('[data-edge-stage]') || event.touches.length !== 1) return;
        this.touchStart = { x: event.touches[0].clientX, y: event.touches[0].clientY };
      }, { ...options, passive: true });
      this.addEventListener('touchend', event => {
        if (!this.touchStart || !event.changedTouches.length) return;
        const dx = event.changedTouches[0].clientX - this.touchStart.x;
        const dy = event.changedTouches[0].clientY - this.touchStart.y;
        this.touchStart = null;
        if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.4) this.select(this.index + (dx < 0 ? 1 : -1), false, true);
      }, { ...options, passive: true });
      this.addEventListener('touchcancel', () => { this.touchStart = null; }, options);
      document.addEventListener('shopify:block:select', event => {
        const index = this.panels.findIndex(panel => panel.dataset.blockId === event.detail?.blockId);
        if (index >= 0) this.select(index, false, false);
      }, options);
      this.select(0, false, false);
      this.dataset.enhanced = 'true';
      this.updateMotion();
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        this.dataset.inView = String(this.inView);
        if (this.inView && !this.warmed) {
          this.querySelectorAll('.edge-motion__image').forEach(image => { image.loading = 'eager'; });
          this.warmed = true;
        }
        this.queueScroll();
      }, { threshold: 0.05 });
      this.observer.observe(this);
      window.addEventListener('scroll', () => this.queueScroll(), { ...options, passive: true });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.dataset.inView = 'false';
        else this.dataset.inView = String(Boolean(this.inView));
      }, options);
    }
    select(index, focus, announce) {
      this.index = ((index % this.panels.length) + this.panels.length) % this.panels.length;
      this.panels.forEach((panel, i) => { panel.hidden = i !== this.index; });
      this.tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === this.index));
        tab.tabIndex = i === this.index ? 0 : -1;
      });
      this.resetTilt();
      if (focus) this.tabs[this.index].focus({ preventScroll: true });
      if (announce && this.status) this.status.textContent = this.panels[this.index].dataset.label;
    }
    updateMotion() {
      this.moving = this.motionAllowed && !this.manualPause && !this.reduced.matches;
      this.dataset.paused = String(!this.moving);
      if (this.pauseButton) {
        this.pauseButton.setAttribute('aria-pressed', String(!this.moving));
        this.pauseButton.disabled = this.reduced.matches;
      }
      if (!this.moving) {
        this.resetTilt();
        this.style.setProperty('--edge-scroll', '0px');
      }
    }
    resetTilt() {
      this.querySelectorAll('[data-edge-pack]').forEach(pack => {
        pack.style.setProperty('--edge-tilt-x', '0deg');
        pack.style.setProperty('--edge-tilt-y', '0deg');
      });
    }
    queueScroll() {
      if (!this.inView || !this.moving || this.frame || document.hidden) return;
      this.frame = requestAnimationFrame(() => {
        const box = this.getBoundingClientRect();
        const progress = Math.max(-1, Math.min(1, (innerHeight * .5 - box.top - box.height * .5) / innerHeight));
        this.style.setProperty('--edge-scroll', `${progress * 28}px`);
        this.frame = null;
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["beauty-stores"] && !Shopify.designMode) return;
  try {
    
function beautyStoresInit(){document.querySelectorAll('[data-beauty-stores]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='1';const frame=root.querySelector('iframe'),current=root.querySelector('.bs-current');root.querySelectorAll('[data-store-map]').forEach(button=>button.addEventListener('click',()=>{let url;try{url=new URL(button.dataset.storeMap)}catch{return}if(url.protocol!=='https:'||url.hostname!=='www.google.com'||url.pathname!=='/maps/embed')return;root.querySelectorAll('[data-store-map]').forEach(other=>{other.setAttribute('aria-pressed',String(other===button));other.closest('.bs-store').classList.toggle('is-selected',other===button)});frame.src=url.href;frame.title=button.dataset.mapTitle;current.textContent=button.dataset.mapTitle}))})}beautyStoresInit();document.addEventListener('shopify:section:load',beautyStoresInit);

  } catch(e) { console.error(e); }
})();
})();
